import { ApiProperty } from "@nestjs/swagger";

export class LotNumberRequest{
    @ApiProperty()
    lotNumber:string;
}